import { v4 as uuid } from 'uuid'
import { convertPath } from './usePageView'
import { newTrack } from '@/track'

interface TOptions {
  input: string
  currentPage: string
  currentPageOpenTime: string
  resultPageOpenTime: string
  duration: string
}

export function searchTrack(options: TOptions) {
  if (options.currentPage === '/')
    options.currentPage = 'index'

  newTrack('biz_search', {
    'input': options.input,
    'current_page': convertPath(options.currentPage),
    'current_page:open_time': options.currentPageOpenTime,
    'result_page:open_time': options.resultPageOpenTime,
    'duration': Math.floor(Number(options.duration) / 1000) || 0,
    'SessionId': uuid(),
  })
}
